import React from 'react';
import PropTypes from 'prop-types';
import {useDispatch, useSelector} from 'react-redux';
import MenuCollapseButton from '../../MenuCollapseButton';
import {mainActions} from '../../../state/actions/main.actions';
import Notifications from '../../Notifications/Notifications';
import BreadCrumbs from '../../BreadCrumbs';
import ProfileDropdown from '../../ProfileDropdown/ProfileDropdown';
import {useCurrentUser} from '../../../hooks';
import {
  StyledHeaderButton,
  StyledHeaderButtons,
  StyledHeaderContent,
  StyledHeaderToolbar,
  StyledPageHeader
} from './StyledPageHeader';

const PageHeader = ({
  breadcrumbs = [],
  buttons,
  leftSideContent,
  onTitleClick,
  ...rest
}) => {
  const dispatch = useDispatch();

  const currentUser = useCurrentUser();
  const isOpenMenu = useSelector((state) => state.main?.isOpenMenu ?? false);
  const notificationCount = useSelector((state) => state.user?.notificationCount?.unread ?? 0);

  const handleOnMenuClick = () => dispatch(mainActions.collapseNavigationMenu());

  const user = {
    logo: currentUser?.logo || undefined,
    name: currentUser?.full_name || '',
  };

  return (
    <StyledPageHeader {...rest}>
      <StyledHeaderContent>
        <MenuCollapseButton
          onClick={handleOnMenuClick}
          variant={isOpenMenu ? 'expand' : 'collapse'}
        />
        {breadcrumbs.length > 0 && <BreadCrumbs items={breadcrumbs} />}
        {leftSideContent && leftSideContent}
      </StyledHeaderContent>
      <StyledHeaderContent>
        <StyledHeaderButtons>
          {buttons && buttons.map((button, key) =>
            <StyledHeaderButton key={key}>{button}</StyledHeaderButton>)}
        </StyledHeaderButtons>
        <StyledHeaderToolbar
          notificationCount={notificationCount}
          notificationDropdownRender={() => <Notifications />}
          profileDropdownRender={() => <ProfileDropdown />}
          user={user}
        />
      </StyledHeaderContent>
    </StyledPageHeader>
  );
};

PageHeader.propTypes = {
  breadcrumbs: PropTypes.arrayOf(
    PropTypes.shape({
      href: PropTypes.any,
      title: PropTypes.string.isRequired,
    })
  ),
  buttons: PropTypes.array,
  leftSideContent: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  onTitleClick: PropTypes.func
};

export default PageHeader;
